import './town.css';
import tumbleweedSprite from './Tumbleweed.png';

interface ITumbleweedProps  {
    top: number;
  };

export default function Tumbleweed(props: ITumbleweedProps) {
    return (
      <div className="tumbleweed-container" style={{ top: `${props.top}px` }}>
        <div
          className="tumbleweed"
          style={{
            backgroundImage: `url(${tumbleweedSprite})`,
          }}
        />
      </div>
    );
  }